module.exports = __webpack_public_path__ + "media/images/iconRight__inactive-3ffede05819a7922be5792886261cadf.png";